export default __webpack_public_path__ + "static/media/logo-cropped.dc16199e.svg";